module.exports = __webpack_public_path__ + "static/media/saude-indigena.e7b6d8e5.jpeg";